<template>
  <v-card-text class="pt-4 px-0 d-flex flex-column align-center">
    <div :style="`transform: rotate(${angle}deg);`">
      <ShaftImage
        :shaft="shaft"
        :showLabels="true"
        :angle="angle"
        :circleSize="circleSize"
      />
    </div>
    <v-text-field
      v-model="outputAngle"
      type="number"
      suffix="°"
      outlined
      center
      class="angle-input mt-4"
      readonly
    >
    </v-text-field>
  </v-card-text>
</template>

<script>
import ShaftImage from '@/components/ShaftImage.vue';

export default {
  name: 'DialogSensorInput',
  components: { ShaftImage },
  props: ['visible', 'shaft', 'type', 'title', 'disabled'],
  data: () => ({
    dialogVisible: false,
    angle: 0,
    outputAngle: 0,
    shaftInput: undefined,
  }),
  computed: {
    circleSize() {
      if (this.type === 'output_channel') return 500;
      return 385;
    },
  },
  watch: {
    angle() {
      if (this.type === 'side_channel')
        this.outputAngle = this.flipDegrees(this.angle);
      else this.outputAngle = this.angle;
    },
    outputAngle() {
      if (this.type === 'side_channel')
        this.angle = this.flipDegrees(this.outputAngle);
      else this.angle = this.outputAngle;
    },
    visible() {
      this.dialogVisible = this.visible;
    },
    dialogVisible() {
      if (this.dialogVisible) {
        this.shaftInput = undefined;
        this.$nextTick(() => {
          this.shaftInput = this.shaft;
        });
      }
    },
  },
  mounted() {
    if (this.type === 'side_channel') this.angle = 180;
    if (window.DeviceOrientationEvent) {
      window.addEventListener(
        'deviceorientation',
        this.handleOrientationChange,
      );
    }
  },
  methods: {
    handleOrientationChange(event) {
      this.angle = parseInt(event.alpha);
    },
    flipDegrees(degrees) {
      // for side channels flip the coordinate system
      // 0° in the bottom, <0 left, >0 right
      if (degrees >= 0) return 180 - degrees;
      else return -(180 + degrees);
    },
    onOkClick() {
      this.$emit('angleChanged', this.outputAngle);
      this.dialogVisible = false;
    },
    onAngleChanged(angle) {
      // only set angle (which serves as input for the angle input control) if it has changed to avoid infinite loop
      if (this.angle != parseInt(angle)) {
        this.angle = parseInt(angle);
      }
      // do clipping for output channels, only -90 <> 90° allowed
      if (this.type === 'output_channel' && this.outputAngle > 90)
        this.outputAngle = 90;
      if (this.type === 'output_channel' && this.outputAngle < -90)
        this.outputAngle = -90;
    },
  },
};
</script>

<style scoped>
.angle-input {
  width: 200px;
}

.angle-input >>> input {
  text-align: center;
}

.angle-input-title {
  font-family: 'Playfair Display' !important;
}
</style>
